import { Synchronized } from '#common/util';
import { BasePointerKind } from '#external-files/types';
import { parseWasmResult } from '#wasm/common';
export class ReadLayoutResult {
    blocks;
    basePtr;
    getObjectSize = 0;
    getObjectCount = 0;
    constructor() {
        this.basePtr = { kind: BasePointerKind.NONE };
    }
}
export class LogStoreWasm extends Synchronized {
    mod;
    constructor(mod, mutex) {
        super(mutex);
        this.mod = mod;
    }
    async readLayout(inodeId, layoutKvs, startBlock, limitBlock) {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.ReadLayout(inodeId, layoutKvs, startBlock, limitBlock));
        });
    }
    async preparePutOperation(inodeId, rootPointer, version, blocks) {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.PreparePutOperation(inodeId, rootPointer, version, blocks));
        });
    }
}
